/***********************************
  ContactFormSelector Module
************************************/

Quad.FormHandlers = ( function() {


  // PRIVATE VARS
  //~~~~~~~~~~~~~~~~~~~~~~~~~~~

  var $contactFooterForm = $( '#contact-footer-form' ),
      $contactPageForm = $( '#contact-page-form' ),
      $newsletterForm = $( '#newsletter-form' ),
      $forms = $( '#contact-footer-form,#contact-page-form,#newsletter-form' );


  // PRIVATE METHODS
  //~~~~~~~~~~~~~~~~~~~~~~~~~~~
  function _init() {

    /*
     *
     * All Quad forms:
     * 1. Contact page (/contact-us/)
     * 2. Contact Footer (i.e. /resources/)
     * 3. Newsletter sign up (footer)
     *
     */

     //change form selection dynajicllay
     var formVars = getUrlVars();

     if ( formVars.length != 0 ) {
      $contactPageForm.find( '#form-type-selector' ).val( formVars[ 's' ]);
     }

     $( '#quote-request-btn' ).click( function() {
      $( '#fieldset' ).removeClass().addClass( 'fieldset quote' );
      $contactPageForm.find( '#form-type-selector' ).val( 'quote' );
      $( '.select-wrapper ul>li:first' ).text( 'Request a Quote' );
     });


     /************************
        1. Contact Page
      ************************/

     $contactPageForm.validate({
      debug: false,
      submitHandler: function( formData ) {

        var formAction = $( '#form-type-selector' ).val();

        var newsLetterSignup = true;

        if ( !$( '#contact-page-form #NewsletterSignup' ).prop( 'checked' )) {
          newsLetterSignup = false;
        }

        if ( formAction == 'general' || formAction == 'investor' || formAction == null ) {
            var data = { action: 'pardotApiMainContact',
            formAction: formAction,
            email: $( '#contact-page-form #EmailAddress' ).val(),
            firstName: encodeURIComponent($( '#contact-page-form #FirstName' ).val()),
            lastName: encodeURIComponent($( '#contact-page-form #LastName' ).val()),
            phoneNumber: encodeURIComponent($( '#contact-page-form #PhoneNumberNonReq' ).val()),
            companyName: encodeURIComponent($( '#contact-page-form #organization' ).val()),
            seniority: $( '#contact-page-form #Seniority' ).val(),
            comments: encodeURIComponent($( '#contact-page-form #Comments' ).val()),
            newsletter: false,
            honey: $( '#contact-page-form #pardot_extra_field' ).val() };

        } else if ( formAction == 'quote' ) {
            var data = { action: 'pardotApiMainContact',
            formAction: formAction,
            email: $( '#contact-page-form #EmailAddress' ).val(),
            firstName: $( '#contact-page-form #FirstName' ).val(),
            lastName: $( '#contact-page-form #LastName' ).val(),
            phoneNumber: $( '#contact-page-form #PhoneNumber' ).val(),
            companyName: $( '#contact-page-form #organizationQuote' ).val(),
            seniority: $( '#contact-page-form #Seniority' ).val(),
            projectDescription: encodeURIComponent($( '#contact-page-form #DescriptionQuote' ).val()),
            country: $( '#contact-page-form #Country' ).val(),
            city: $( '#contact-page-form #city' ).val(),
            zip: $( '#contact-page-form #zip' ).val(),
            website: $( '#contact-page-form #url' ).val(),
            department: $( '#contact-page-form #Department' ).val(),
            industry: $( '#contact-page-form #Industry' ).val(),
            newsletter: newsLetterSignup,
            honey: $( '#contact-page-form #pardot_extra_field' ).val() };

          } else if ( formAction == 'supplier' ) {
            var data = { action: 'pardotApiMainContact',
            formAction: formAction,
            email: $( '#contact-page-form #EmailAddress' ).val(),
            firstName: $( '#contact-page-form #FirstName' ).val(),
            lastName: $( '#contact-page-form #LastName' ).val(),
            phoneNumber: $( '#contact-page-form #PhoneNumber' ).val(),
            companyName: encodeURIComponent($( '#contact-page-form #organization' ).val()),
            comments: encodeURIComponent($( '#contact-page-form #Comments' ).val()),
            newsletter: false,
            honey: $( '#contact-page-form #pardot_extra_field' ).val() };

          } else if ( formAction == 'media' ) {
            var data = { action: 'pardotApiMainContact',
            formAction: formAction,
            email: $( '#contact-page-form #EmailAddress' ).val(),
            firstName: $( '#contact-page-form #FirstName' ).val(),
            lastName: $( '#contact-page-form #LastName' ).val(),
            phoneNumber: $( '#contact-page-form #PhoneNumberNonReq' ).val(),
            companyName: encodeURIComponent($( '#contact-page-form #organization' ).val()),
            comments: encodeURIComponent($( '#contact-page-form #Comments' ).val()),
            newsletter: false,
            honey: $( '#contact-page-form #pardot_extra_field' ).val() };
          }

        $( '#contact-page-form #submit' ).html( '<span class="icon-send"></span>Submitting...' );


        $.post( '/wp-admin/admin-ajax.php', data, function( response ) {
            var result = JSON.parse( response );

            console.log( result );

            if ( result.success == true ) {
              //show success
              $( '#contact-page-form #submit' ).html( '<span class="icon-check">Thank you!' );
              window.setTimeout( function() {
                $( '#contact-page-form #submit' ).html( '<span class="icon-send"></span>Submit' );
              }, 3000 );
              clearMainContactForm();
            } else {
              //show error

              console.log( result );

              $( '#contact-page-form #submit' ).after( '<p>Sorry, there was an error. Please try again.' );
              $( '#contact-page-form #submit' ).html( '<span class="icon-send"></span>Submit' );
            }
       });


      }
     });


     /************************
        2. Contact Footer
      ************************/


     $( $contactFooterForm ).validate({
      debug: false,
      submitHandler: function( formData ) {

        var data = { action: 'pardotApiInlineContact',
        email: $( '#contact-footer-form #EmailAddress' ).val(),
        firstName: encodeURIComponent($( '#contact-footer-form #FirstName' ).val()),
        lastName: encodeURIComponent($( '#contact-footer-form #LastName' ).val()),
        phoneNumber: encodeURIComponent($( '#contact-footer-form #PhoneNumber' ).val()),
        companyName: encodeURIComponent($( '#contact-footer-form #organization' ).val()),
        seniority: $( '#contact-footer-form #Seniority' ).val(),
        comments: encodeURIComponent($( '#contact-footer-form #Comments' ).val()),
        source: $( '#contact-footer-form #SubmittedFrom' ).val() };

        $( '#contact-footer-form #submit' ).html( '<span class="icon-send"></span>Submitting...' );


        $.post( '/wp-admin/admin-ajax.php', data, function( response ) {
            var result = JSON.parse( response );
            if ( result.success == true ) {
              //show success
              $( '#contact-footer-form #submit' ).html( '<span class="icon-check">Thank you!' );
              window.setTimeout( function() {
                $( '#contact-footer-form #submit' ).html( '<span class="icon-send"></span>Submit' );
              }, 3000 );
              clearInlineContactForm();
            } else {
              //show error

              console.log( result );

              $( '#contact-footer-form #submit' ).after( '<p>Sorry, there was an error. Please try again.' );
              $( '#contact-footer-form #submit' ).html( '<span class="icon-send"></span>Submit' );
            }
       });


      }
     });


     /************************
        3. Newsletter
      ************************/


     $( $newsletterForm ).validate({
      debug: false,
      submitHandler: function( formData ) {

        var newsLetterSignup = true;

        var data = { action: 'pardotApiNewsletter',
            email: $( '#newsletter-form #EmailAddress' ).val(),
            newsletter: newsLetterSignup,
            source: $( '#newsletter-form #SubmittedFrom' ).val() };

        $( '#newsletter-form #submit' ).html( '<span class="icon-send"></span>Submitting...' );

        $.post( '/wp-admin/admin-ajax.php', data, function( response ) {
            var result = JSON.parse( response );
            if ( result.success == true ) {
              //show success
              $( '#newsletter-form #submit' ).html( '<span class="icon-check">Thank you!' );
              window.setTimeout( function() {
                $( '#newsletter-form #submit' ).html( '<span class="icon-send"></span>Submit' );
              }, 3000 );

              $( '#newsletter-form #EmailAddress' ).val( '' );
            } else {
              //show error
              $( '#newsletter-form #submit' ).after( '<p>Sorry, there was an error. Please try again.' );
              $( '#newsletter-form #submit' ).html( '<span class="icon-send"></span>Submit' );
            }
       });

      }
     });

  }


  function clearMainContactForm() {
    $( '#contact-page-form #EmailAddress' ).val( '' );
    $( '#contact-page-form #FirstName' ).val( '' );
    $( '#contact-page-form #LastName' ).val( '' );
    $( '#contact-page-form #PhoneNumber' ).val( '' );
    $( '#contact-page-form #PhoneNumberNonReq' ).val( '' );
    $( '#contact-page-form #organization' ).val( '' );
    $( '#contact-page-form #Seniority' ).val( '' );
    $( '#contact-page-form #Description' ).val( '' );
    $( '#contact-page-form Country' ).val( '' );
    $( '#contact-page-form #Zip' ).val( '' );
    $( '#contact-page-form #url' ).val( '' );
    $( '#contact-page-form #Department' ).val( '' );
    $( '#contact-page-form #Industry' ).val( '' );
    $( '#contact-page-form #DescriptionQuote' ).val();
    $( '#contact-page-form #Country' ).val();
    $( '#contact-page-form #city' ).val();
    $( '#contact-page-form #zip' ).val();


  }

  function clearInlineContactForm() {
    $( '#contact-footer-form #EmailAddress' ).val( '' );
    $( '#contact-footer-form #FirstName' ).val( '' );
    $( '#contact-footer-form #LastName' ).val( '' );
    $( '#contact-footer-form #PhoneNumber' ).val( '' );
    $( '#contact-footer-form #organization' ).val( '' );
    $( '#contact-footer-form #Seniority' ).val( '' );
    $( '#contact-footer-form #Comments' ).val( '' );

  }


  function getUrlVars() {
      var vars = [], hash;
      var hashes = window.location.href.slice( window.location.href.indexOf( '?' ) + 1 ).split( '&' );
      for ( var i = 0; i < hashes.length; i++ ) {
          hash = hashes[ i ].split( '=' );
          vars.push( hash[ 0 ]);
          vars[ hash[ 0 ] ] = hash[ 1 ];
      }
      return vars;
  }

  // PUBLIC METHODS
  //~~~~~~~~~~~~~~~~~~~~~~~~~~~
  return {

    init: _init

  };

})();
